export default __webpack_public_path__ + "locales/pt/ArchiveDialog.json?hash=edbde851f7a31785c57121a566ec7f7d";